import enquire from "../../../../_ui/responsive/common/js/enquire.js";

window.enquire = enquire;
export default enquire;
